import { postDataApi } from "../utils/fech-api";


const BASE_URL = '/api/send/mail';


// Send an Email
export const sendEmail = (userData, headers = {}) => {
    return postDataApi(BASE_URL, userData, headers);
};